import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const SLAPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <Icon name="ArrowLeft" size={24} className="text-gray-600" />
              <span className="font-poppins font-heading-semibold text-lg text-gray-900">Geri Dön</span>
            </Link>
            <h1 className="font-poppins font-heading-bold text-2xl text-gray-900">Hizmet Seviyesi Anlaşması (SLA)</h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600"><strong>Son Güncelleme:</strong> 15 Ocak 2024</p>
          </div>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">1. Kapsam</h2>
            <p className="text-gray-700 leading-relaxed">
              Bu Hizmet Seviyesi Anlaşması (SLA), Cafe Otomasyonu bulut hizmetlerinin kullanılabilirliği, destek kapsamı ve bakım pencereleri hakkında bilgi verir.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">2. Kullanılabilirlik (Uptime)</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Hedef <strong>%99.9</strong> aylık hizmet kullanılabilirliği.</li>
              <li>Planlı bakım bildirimleri en az <strong>24 saat</strong> önce paylaşılır.</li>
              <li>Üçüncü taraf ağ ve altyapı problemleri kapsam dışıdır.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">3. Destek ve Yanıt Süreleri</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong> Kritik (S1):</strong> Servis kesintisi – hedef ilk yanıt <strong>1 saat</strong>, çözüm/çevrim için <strong>4 saat</strong>.</li>
              <li><strong> Yüksek (S2):</strong> Önemli işlev sorunu – hedef ilk yanıt <strong>4 saat</strong>.</li>
              <li><strong> Orta (S3):</strong> Kısmi işlev – hedef ilk yanıt <strong>1 iş günü</strong>.</li>
              <li><strong> Düşük (S4):</strong> Soru/iyileştirme – hedef ilk yanıt <strong>2 iş günü</strong>.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">4. Bakım ve Güncellemeler</h2>
            <p className="text-gray-700 leading-relaxed">
              Planlı bakım çalışmaları genellikle gece saatlerinde gerçekleştirilir. Kritik güvenlik güncellemeleri önceliklidir ve mümkün olan en kısa sürede uygulanır.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">5. Müşteri Yükümlülükleri</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Doğru iletişim bilgileri ve yetkili kişi beyanı.</li>
              <li>Güncel tarayıcı ve cihaz kullanımı; ağ erişiminin sağlanması.</li>
              <li>Güvenlik tavsiyelerine uyum (parola politikası, erişim yetkileri vb.).</li>
            </ul>
          </section>

          <section>
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">6. İletişim</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>WhatsApp:</strong> +90 507 588 04 81
              </p>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default SLAPage;


